import styled from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import colors from 'utils/styling/colors'

export const Navigation = styled(Flex)`
  outline: 1px solid ${colors('lockedWhite', 10)};
`
